import risToFevirCall from "./risToFevirConverterAPI";

const convertRIStoFHIR = async (apiToken, risEntryState, risMappingState, setFhirOutputState) => {
    let mapping = {};
    let mappingValues = {};

    for (let index in risMappingState) {
        let entry = risMappingState[index];
        let tempValue = entry["Meaning"];
        if (entry["modifier"]) {
            let modifierJson = JSON.parse(entry["modifier"]);
            tempValue = modifierJson["Meaning"];
        } else if (entry.ModifierMapping?.selected) {
            tempValue = entry["ModifierMapping"]["Meaning"];
        }
        if (tempValue !== "NOT MAPPED") {
            if (mappingValues[tempValue]) {
                alert(`Multiple mappings for ${tempValue} found: ${mappingValues[tempValue]} and ${entry["RISCode"]}`);
            }
            mapping[entry["RISCode"]] = tempValue;
            mappingValues[tempValue] = entry["RISCode"];
        }
    }
    let risValue = risEntryState.text || risEntryState.risFile;
    let response = await risToFevirCall(risValue, apiToken, JSON.stringify(mapping));
    if (response.success === false) {
        alert("We were unable to convert this RIS data. Check the formatting, and let us know if you need us to investigate.");
    } else {
        if (response["jsonarraystring"]) {
            let jsonarray = JSON.parse(response["jsonarraystring"]);
            if (setFhirOutputState) {
                setFhirOutputState(JSON.stringify(jsonarray, null, 2));
            }
            return jsonarray;
        }
    }
}
export default convertRIStoFHIR;